import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, unref as _unref, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pp-lottery-winnings" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "pp-lottery-winnings__title"
}
const _hoisted_7 = ["innerHTML"]

import { StringUtils } from "@sazka/utils/string-utils";
import { PpDraw } from "@/lotteries/services/model/draw";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import { Lottery } from "@sazka/lotteries/js/models/lottery";
import PpAddonWinnings from "@/lotteries/product-page/components/results/pp-addon-winnings.vue";
import PpSpecialPrizeWinnings from "./pp-special-prize-winnings.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'pp-sportka-winnings',
  props: {
    results: {}
  },
  setup(__props: any) {



const formatNumberOfWinners = (winners: number) => `(${StringUtils.formatNumber(winners)}x)`;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DsTable, null, {
      default: _withCtx(() => [
        _createVNode(DsRow, null, {
          default: _withCtx(() => [
            _createVNode(DsCell, {
              type: "th",
              "data-test": "table-winnings-1-1"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("Pořadí")
              ])),
              _: 1,
              __: [0]
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results.mainGameWinnings[0].length, (_, setIndex) => {
              return (_openBlock(), _createBlock(DsCell, {
                type: "th",
                key: setIndex,
                "data-test": `table-winnings-${setIndex + 2}-1`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(setIndex + 1) + ". tah ", 1)
                ]),
                _: 2
              }, 1032, ["data-test"]))
            }), 128))
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results.mainGameWinnings, (orderWinnings, orderIndex) => {
          return (_openBlock(), _createBlock(DsRow, { key: orderIndex }, {
            default: _withCtx(() => [
              _createVNode(DsCell, {
                "data-test": `table-winnings-1-${orderIndex + 2}`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(orderIndex === 0 ? "Bonus" : `${orderIndex}. pořadí`), 1)
                ]),
                _: 2
              }, 1032, ["data-test"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderWinnings, (winning, setIndex) => {
                return (_openBlock(), _createBlock(DsCell, {
                  "data-test": `table-winnings-${setIndex + 2}-${orderIndex + 2}`,
                  key: setIndex
                }, {
                  default: _withCtx(() => [
                    (winning.amount && winning.wins)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createElementVNode("strong", {
                            innerHTML: _unref(StringUtils).formatCurrency(winning.amount)
                          }, null, 8, _hoisted_3),
                          _createElementVNode("span", {
                            innerHTML: ' ' + formatNumberOfWinners(winning.wins)
                          }, null, 8, _hoisted_4)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_5, "–––"))
                  ]),
                  _: 2
                }, 1032, ["data-test"]))
              }), 128))
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    (_ctx.results.estimatedJackpots)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_6, "Předpokládané částky Jackpotů"))
      : _createCommentVNode("", true),
    (_ctx.results.estimatedJackpots)
      ? (_openBlock(), _createBlock(DsTable, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(DsRow, null, {
              default: _withCtx(() => [
                _createVNode(DsCell, {
                  type: "th",
                  "data-test": "table-jackpots-1-1"
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("Pořadí")
                  ])),
                  _: 1,
                  __: [1]
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results.estimatedJackpots[0].length, (_, i) => {
                  return (_openBlock(), _createBlock(DsCell, {
                    type: "th",
                    key: i,
                    "data-test": `table-jackpots-${i + 2}-1`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(i + 1) + ". tah ", 1)
                    ]),
                    _: 2
                  }, 1032, ["data-test"]))
                }), 128))
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results.estimatedJackpots, (orders, orderIndex) => {
              return (_openBlock(), _createBlock(DsRow, { key: orderIndex }, {
                default: _withCtx(() => [
                  _createVNode(DsCell, {
                    "data-test": `table-jackpots-1-${orderIndex + 2}`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(orderIndex + 1) + ". pořadí", 1)
                    ]),
                    _: 2
                  }, 1032, ["data-test"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orders, (set, setIndex) => {
                    return (_openBlock(), _createBlock(DsCell, {
                      "data-test": `table-jackpots-${setIndex + 2}-${orderIndex + 2}`,
                      key: setIndex
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("strong", {
                          innerHTML: _unref(StringUtils).formatCurrency(set)
                        }, null, 8, _hoisted_7)
                      ]),
                      _: 2
                    }, 1032, ["data-test"]))
                  }), 128))
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.results.addonWinnings)
      ? (_openBlock(), _createBlock(PpAddonWinnings, {
          key: 2,
          lottery: _unref(Lottery).sportka,
          winnings: _ctx.results.addonWinnings
        }, null, 8, ["lottery", "winnings"]))
      : _createCommentVNode("", true),
    _createVNode(PpSpecialPrizeWinnings, {
      lottery: _unref(Lottery).sportka,
      specialPrizes: _ctx.results.specialPrizes
    }, null, 8, ["lottery", "specialPrizes"])
  ]))
}
}

})